import { combineReducers } from 'redux';
import { expandedKeysReducer } from './expanded-keys/expandedKeysReducer';
import { globalReducer } from './global/globalReducer';

export const persistedReducer = combineReducers({
    expandedKeys: expandedKeysReducer,
    global: globalReducer
});
